import { createContext, useState } from 'react';

export const GestionCenterContext = createContext();

export const GestionCenterProvider = ({ children }) => {
  const [inputValueSearch, setInputValueSearch] = useState(null);
  const [inputAfter, setInputAfter] = useState('');

  const data = {
    inputValueSearch,
    setInputValueSearch,
    inputAfter,
    setInputAfter,
  };

  return <GestionCenterContext.Provider value={data}>{children}</GestionCenterContext.Provider>;
};
